"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTypeString = void 0;
var isTypeString = function (value) {
    return typeof value === "string";
};
exports.isTypeString = isTypeString;
//# sourceMappingURL=isTypeString.js.map